import { EnumDescriptions } from '@/app/shared/utils/enum-descriptions';
import Vue from 'vue';

Vue.filter('capitalize', (value: string) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('capitalizeOne', (value: string) => {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase();
});

Vue.filter('nameAvatar', (value: string) => {
  if (!value) return '';
  value = value.toString();
  return value
    .split(/\s/)
    .reduce(
      (response: string, word: string) =>
        (response += word.slice(0, 1).toUpperCase()),
      ''
    )
    .slice(0, 2);
});

Vue.filter('description', (value: string, enumClass: {}) => {
  if (!enumClass) return '--';
  return EnumDescriptions.get2(enumClass, value);
});

Vue.filter('monthYear', (value: string) => {
  if (!value) return '--';
  return value.slice(-2) + '/' + value.slice(0, 4);
});
